import { render, staticRenderFns } from "./interactiveqadetails.vue?vue&type=template&id=51d5277a&scoped=true&"
import script from "./interactiveqadetails.vue?vue&type=script&lang=js&"
export * from "./interactiveqadetails.vue?vue&type=script&lang=js&"
import style0 from "./interactiveqadetails.vue?vue&type=style&index=0&id=51d5277a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5277a",
  null
  
)

export default component.exports